function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon{fill:#95A1B2;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.484 11.484)"
}, /*#__PURE__*/React.createElement("path", {
  className: "icon",
  d: "M222.414,241H210.82a.82.82,0,0,0,0,1.641h11.594a.82.82,0,0,0,0-1.641Z",
  transform: "translate(-210 -241)"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.484 14.766)"
}, /*#__PURE__*/React.createElement("path", {
  className: "icon",
  d: "M217.492,301H210.82a.82.82,0,0,0,0,1.641h6.672a.82.82,0,1,0,0-1.641Z",
  transform: "translate(-210 -301)"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "icon",
  d: "M25.539,37.563H19.8v-4.1A2.464,2.464,0,0,0,17.336,31H2.461A2.464,2.464,0,0,0,0,33.461V43.3a2.464,2.464,0,0,0,2.461,2.461h.82v2.461a.82.82,0,0,0,1.275.683L8.2,46.478v3.389a2.464,2.464,0,0,0,2.461,2.461h8.064l4.715,3.143a.82.82,0,0,0,1.275-.683V52.328h.82A2.464,2.464,0,0,0,28,49.867V40.023A2.464,2.464,0,0,0,25.539,37.563ZM8.2,40.023v4.483L4.922,46.694V44.945a.82.82,0,0,0-.82-.82H2.461a.821.821,0,0,1-.82-.82V33.461a.821.821,0,0,1,.82-.82H17.336a.821.821,0,0,1,.82.82v4.1H10.664A2.464,2.464,0,0,0,8.2,40.023Zm18.156,9.844a.821.821,0,0,1-.82.82H23.9a.82.82,0,0,0-.82.82v1.748l-3.647-2.431a.82.82,0,0,0-.455-.138H10.664a.821.821,0,0,1-.82-.82V40.023a.821.821,0,0,1,.82-.82H25.539a.821.821,0,0,1,.82.82Z",
  transform: "translate(0 -31)"
});

var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24.609,
    viewBox: "0 0 28 24.609",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat.345c9f0b.svg";
export { ForwardRef as ReactComponent };